import dayjs from "dayjs";
import type {
	ClientPortfolioReportingSummaryResponseDTO,
	PortfolioReportingEntryResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { roundNumber } from "web_myplann/Shared/Utils/numberFormatters";

export type DayData = {
	date: Date;
	invested: number;
	value: number;
};

export const calculateGraphData = (
	data: PortfolioReportingEntryResponseDTO[] | undefined,
	summary: ClientPortfolioReportingSummaryResponseDTO | undefined,
): {
	daysData: DayData[];
	totalValue: number;
	totalInvestedValue: number;
	toDate: string;
	showChartInfo: boolean;
} => {
	if (!data || data.length === 0)
		return {
			daysData: [],
			totalValue: 0,
			totalInvestedValue: 0,
			toDate: "",
			showChartInfo: false,
		};

	const daysData = data
		.filter((day) => day.items.length > 0)
		.map((day) => ({
			date: new Date(day.date),
			invested: (day.items[0].invested ?? 0) + day.items[0].totalEntryFee,
			value: day.items[0].value,
		}));

	const lastData = daysData[daysData.length - 1];

	const investedValue = summary?.totalInvestedValue ?? null;
	const evaluationValue = summary?.totalEvaluationValue ?? null;
	const evaluationPercent = summary?.totalEvaluationPercent ?? null;

	const totalValue = roundNumber(summary?.totalValue ?? 0, 0);
	const totalInvestedValue = roundNumber(investedValue ?? 0, 0);
	const toDate = dayjs(lastData?.date).format("D.M.YYYY");
	const showChartInfo =
		investedValue !== null &&
		evaluationValue !== null &&
		evaluationPercent !== null;

	return {
		daysData,
		totalValue,
		totalInvestedValue,
		toDate,
		showChartInfo,
	};
};
